import CMSWrapper from '@/features/shared/CMSWrapper';
import { resolveBool, resolveColorName, resolveTheme } from '@/utils/resolvers';
import React, { useRef } from 'react';
import { navigationItemsResolver } from './PortalNavigation.resolvers';
import { PortalNavigatorMapper } from '@/features/PortalNavigation/PortalNavigation.mapper';

const PortalNavigationCMSWrapper = (brProps: any) => {
  const mapping = useRef({
    document: [
      'content',
      {
        menuGroup: ['navigationItems', navigationItemsResolver],
      },
    ],
    includeBackLink: ['includeBackButton', resolveBool],
    'portalNavigation.labels': 'labels',
    componentParameterMap: [
      'presentation',
      {
        'variant-label': 'datalayerVariant',
        'container-background-color': ['containerBackgroundColor', resolveColorName],
      },
    ],
  });

  const requiredFields = useRef({
    document: '<b>Portal Navigation Content</b> is required',
  });

  const contentButtonNames = useRef({
    document: 'content',
  });

  return (
    <CMSWrapper
      brProps={brProps}
      render={PortalNavigatorMapper}
      mapping={mapping.current}
      requiredFields={requiredFields.current}
      contentButtonNames={contentButtonNames.current}
    />
  );
};

export default PortalNavigationCMSWrapper;
